import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../css/ConfirmModal.css"; 

const ConfirmModal = ({ title, message, icon, isVisible, onConfirm, onCancel, iconBorder }) => {
  if (!isVisible) return null;

  return (
    <div className="popup-modal-overlay">
      <div className="popup-modal-content">
        {icon && (
                  <div className={iconBorder}>
                    <FontAwesomeIcon icon={icon} size="3x"/>
                  </div>
                )}
        <h2 className="success-title">{title}</h2>
        {message && <p className="popup-modal-message">{message}</p>}
        <div>
          <button className="popup-modal-button" onClick={onConfirm}>
            Yes
          </button>
          <button className="popup-modal-button" style={{ backgroundColor: "#6c757d", marginLeft: "10px" }} onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
